export const ROUTE_PATHS = {
  riskAssessment: 'risk-assessment',
  assayManagement: 'assay-management'
} as const;